module.exports = __webpack_public_path__ + "img/logo-genesis-new.58bb8e76.svg";